/**
 * Swiper for resource-list carousels only (not card-slider).
 * Exposed for lazy Section Rendering hydration (e.g. product recommendations).
 */
function initResourceListSwipers(root) {
    const scope = root && root.querySelectorAll ? root : document;
    if (typeof Swiper === 'undefined') return;

    scope.querySelectorAll('[data-resource-list-swiper]').forEach((el) => {
        if (el.classList.contains('swiper-initialized')) return;

        // Nav buttons may live in a sibling header (e.g. `.card-slider__header`),
        // so walk up to the nearest wrapping container before falling back to `el`.
        const navScope =
            el.closest('.card-slider, product-recommendations, [data-resource-list-root]') || el;
        const prevEl = navScope.querySelector('.slideshow-control--previous');
        const nextEl = navScope.querySelector('.slideshow-control--next');
        const hasNav = prevEl && nextEl;

        new Swiper(el, {
            slidesPerView: 1.09,
            spaceBetween: 2,
            speed: 400,
            watchOverflow: true,
            breakpoints: {
                768: {
                    slidesPerView: 2.09,
                },
                1024: {
                    slidesPerView: 4,
                },
            },
            ...(hasNav ? { navigation: { prevEl, nextEl } } : {}),
        });
    });
}

window.initResourceListSwipers = initResourceListSwipers;

document.addEventListener('DOMContentLoaded', () => {
    initResourceListSwipers(document);
});
